module.exports = __webpack_public_path__ + "media/images/social_preview-1a822a3cb6d1fbc0c9ad48f2c93c1c20.jpg";